var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"scania-dash wrapper",scopedSlots:_vm._u([{key:"default",fn:function(dashProps){return [_c('div',{staticClass:"dashboard game-connected",style:({
        transform: `scale(${dashProps.currentScale}) translate(-50%, -50%)`,
        width: dashProps.skinData.size.width + 'px',
        height: dashProps.skinData.size.height + 'px'
      })},[_c('ScaniaGauges'),_c('div',{staticClass:"symbols"},[_c('ScaniaGeneralWarningSymbols'),_c('ScaniaBodybuilderSymbols'),_c('ScaniaIndicatorSymbols')],1),(_vm.telemetry2.truck.ignitionIsTurnedOn)?_c('ScaniaDisplay'):_vm._e()],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }